/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'raigmore/house': {
    width: 111,
    height: 110,
    viewBox: '0 0 111 110',
    data: '<ellipse pid="0" cx="55.5" cy="55" rx="55.5" ry="55" _fill="#246D95"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M76.589 73.998V54.424L55.936 38.288 35.283 54.424v19.574L51.447 74V60.206h8.978v13.792H76.59z" _fill="#fff"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M31.158 55.365l24.777-19.357 24.927 19.476 2.995-3.765-7.375-5.761V31.387H66.98v7.148L56.057 30l-27.8 21.72 2.901 3.645z" _fill="#fff"/>'
  }
})
